// src/ManageEquipment.js - SOSTITUITO COMPLETAMENTE

import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, addDoc, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { EquipmentModal } from './EquipmentModal'; // Importa il nuovo modale
import { useUser } from './UserContext'; 
import { logAction } from './loggingService';

function ManageEquipment() {
    const { userProfile } = useUser(); // 2. Otteniamo i permessi

    const permissionLevel = userProfile?.permissions?.rooms || 'none';
    const canEdit = permissionLevel === 'completo' || permissionLevel === 'semi-completo';
    const canDelete = permissionLevel === 'completo';
    const [equipment, setEquipment] = useState([]);
    const [specialties, setSpecialties] = useState([]);
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingEquipment, setEditingEquipment] = useState(null); // Per la modifica
    const [searchTerm, setSearchTerm] = useState('');

    // Funzione per caricare tutti i dati necessari
    // Funzione per caricare tutti i dati necessari
const fetchData = async () => {
    // --- INIZIO MODIFICA ---
    if (!userProfile || !userProfile.centerId) {
        setSpecialties([]);
        setEquipment([]);
        return; // Esci se non c'è un centro
    }

    // Carica Specialistiche
    const specialtiesSnapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'specialties')); // <-- MODIFICA QUI
    const specialtiesList = specialtiesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setSpecialties(specialtiesList.sort((a, b) => a.name.localeCompare(b.name)));

    // Carica Macchinari e associa i nomi delle specialistiche
    const equipmentSnapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'equipment')); // <-- MODIFICA QUI
    // --- FINE MODIFICA ---
        const equipmentList = equipmentSnapshot.docs.map(doc => {
            const data = doc.data();
            const specialtyNames = (data.specialtyIds || [])
                .map(id => specialtiesList.find(s => s.id === id)?.name)
                .filter(Boolean); // Filtra via eventuali nomi non trovati
            return {
                id: doc.id,
                ...data,
                specialtyNames: specialtyNames,
            };
        });
        setEquipment(equipmentList.sort((a, b) => a.name.localeCompare(b.name)));
    };

    useEffect(() => {
        fetchData();
    }, [userProfile]); // <-- MODIFICA QUI

    // Funzione unica per salvare (sia creazione che modifica)
    const handleSaveEquipment = async (equipmentData) => {
        const payload = {
            name: equipmentData.name,
            specialtyIds: equipmentData.specialtyIds,
            // Campi diagnostica
            isDiagnostic:   equipmentData.isDiagnostic   ?? false,
            categorieEsami: equipmentData.categorieEsami ?? [],
            protocollo:     equipmentData.protocollo     ?? null,
            produttore:     equipmentData.produttore     ?? null,
            modello:        equipmentData.modello        ?? null,
            // 🎯 FIX: Campi Noleggio
            isRental:       equipmentData.isRental       ?? false,
            quantitaTotale: equipmentData.quantitaTotale ?? 1,
            inUso:          equipmentData.inUso          ?? 0
        };

        if (equipmentData.id) {
            // Modifica
            await updateDoc(doc(db, 'centers', userProfile.centerId, 'equipment', equipmentData.id), payload);
            await logAction(userProfile, `ha modificato il macchinario: ${equipmentData.name}`);
        } else {
            // Creazione
            await addDoc(collection(db, 'centers', userProfile.centerId, 'equipment'), {
                ...payload,
                centerId: userProfile.centerId
            });
            await logAction(userProfile, `ha creato il macchinario: ${equipmentData.name}`);
        }
        setIsModalOpen(false);
        fetchData();
    };

    const handleDeleteEquipment = async (equipmentId) => {
        const equipmentToDelete = equipment.find(e => e.id === equipmentId);
        if (window.confirm("Sei sicuro di voler eliminare questo macchinario?")) {
            await deleteDoc(doc(db, 'centers', userProfile.centerId, 'equipment', equipmentId)); // <-- MODIFICA QUI
           if (equipmentToDelete) {
                await logAction(userProfile, `ha eliminato il macchinario: ${equipmentToDelete.name}`);
            }
            fetchData();
        }
    };
    
    // Funzione per aprire il modale in modalità modifica
    const handleEditClick = (item) => {
        setEditingEquipment(item);
        setIsModalOpen(true);
    };

    // Funzione per aprire il modale in modalità creazione
    const handleNewClick = () => {
        setEditingEquipment(null); // Nessun dato da modificare
        setIsModalOpen(true);
    };

    const filteredEquipment = equipment.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            {isModalOpen && (
                <EquipmentModal
                    equipmentData={editingEquipment}
                    allSpecialties={specialties}
                    onSave={handleSaveEquipment}
                    onClose={() => setIsModalOpen(false)}
                />
            )}

            <div className="management-container">
                <div className="management-header">
                    <h4>Macchinari Esistenti</h4>
                    {canEdit && ( <button onClick={handleNewClick} className="add-new-button">+ Aggiungi Macchinario</button> )}
                </div>

                {/* Barra di ricerca */}
                <div className="filters-container">
                    <input
                        type="text"
                        placeholder="Cerca macchinario per nome..."
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                {/* Lista filtrata */}
                <div className="management-list">
                    {filteredEquipment.map(item => (
                        <div key={item.id} className="management-card">
                            <div className="list-item-content">
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                    <span className="list-item-main-text">{item.name}</span>
                                    {/* 🆕 Badge diagnostica */}
                                    {item.isDiagnostic && (
                                        <span style={{
                                            padding: '3px 10px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600', color: 'white',
                                            backgroundColor: item.protocollo === 'DICOM' ? '#2563eb' : item.protocollo === 'HL7' ? '#059669' : '#7c3aed',
                                        }}>
                                            🔬 {item.protocollo || 'Diagnostico'}
                                        </span>
                                    )}
                                    {/* 🎯 FIX: Badge Noleggio (Disponibilità) */}
                                    {item.isRental && (
                                        <span style={{
                                            padding: '3px 10px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600', color: '#166534', backgroundColor: '#dcfce7', border: '1px solid #86efac'
                                        }}>
                                            📦 Noleggio: {(item.quantitaTotale || 1) - (item.inUso || 0)} disp. su {item.quantitaTotale || 1}
                                        </span>
                                    )}
                                </div>
                                {/* 🆕 Categorie esami (solo se diagnostico) */}
                                {item.isDiagnostic && item.categorieEsami?.length > 0 && (
                                    <div style={{ marginTop: '5px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        {item.categorieEsami.map(cat => (
                                            <span key={cat} style={{
                                                padding: '2px 8px',
                                                borderRadius: '10px',
                                                fontSize: '0.7rem',
                                                backgroundColor: '#dbeafe',
                                                color: '#1e40af',
                                                border: '1px solid #bfdbfe'
                                            }}>
                                                {cat}
                                            </span>
                                        ))}
                                    </div>
                                )}
                                <div className="specialty-tags-container">
                                    {item.specialtyNames.map(name => <span key={name} className="specialty-tag">{name}</span>)}
                                </div>
                            </div>
                            <div className="list-item-actions">
                                {canEdit && <button onClick={() => handleEditClick(item)} className="info-button">Modifica</button>}
                                {canDelete && <button onClick={() => handleDeleteEquipment(item.id)} className="delete-button">Elimina</button>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default ManageEquipment;